import React from "react";
import TableNumberBaseNull from "../TableNumberBaseNull";
import "./TableTextBaseNull.css";

function TableTextBaseNull() {
  return (
    <div className="table-text-base-null">
      <TableNumberBaseNull />
    </div>
  );
}

export default TableTextBaseNull;
